<div class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">
        {{ dataService.res('Ubt-MeasureTask-SubProject') }}
      </h2>
    </div>
    <div
      *appCheckPermission="{
        context: PermissionContext.Subproject,
        action: Action.CREATE,
      }"
    >
      <div fxLayout="column" class="add-button-style">
        <abc-speed-dial-action icon="add" (onClick)="openSubProjectDialog()"> </abc-speed-dial-action>
      </div>
    </div>
  </div>
  <div class="content-block">
    <div class="dx-card responsive-paddings card-radius">
      <dx-data-grid
        #subProjectGrid
        class="grid-group-by-Style grid-adaptive-mode"
        [dataSource]="subProjectsViewModel"
        [noDataText]="noDataText"
        (onRowRemoved)="(false)"
        [height]="'100%'"
        [width]="'100%'"
        [rowAlternationEnabled]="false"
        [columns]="columnsHeader"
        [allowColumnReordering]="false"
        (onCellPrepared)="onCellPrepared($event)"
        (onCellClick)="onCellClick($event)"
        [columnHidingEnabled]="true"
        [wordWrapEnabled]="true"
        [columnAutoWidth]="false"
      >
        <dxo-export [allowExportSelectedData]="false"></dxo-export>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-editing [allowDeleting]="false" [allowAdding]="false"> </dxo-editing>
        <dxo-column-chooser [search]="{ enabled: true }" [enabled]="true"> </dxo-column-chooser>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-group-panel #dxGroup [visible]="false"></dxo-group-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-search-panel [visible]="true"> </dxo-search-panel>
      </dx-data-grid>
    </div>
    <abc-popup
      #createSubProjectPopup
      class="windowTitleBackground"
      [showTitle]="true"
      [showCloseButton]="false"
      [width]="'90%'"
      [maxWidth]="700"
      [height]="'auto'"
      [showCloseButton]="true"
    >
      <div class="dx-card card-paddings card-radius">
        <div fxLayout="column" fxFlexFill fxLayoutGap="10px">
          <form action="post" (submit)="createSubProject($event)">
            <abc-form #form id="form" [(formData)]="subProject" [colCount]="1">
              <dxi-item [isRequired]="true">
                <dx-text-box
                  [(value)]="subProject.Label"
                  [stylingMode]="'outlined'"
                  [width]="'100%'"
                  [label]="dataService.res('Ubt-MeasureTask-Label')"
                  [labelMode]="'floating'"
                >
                </dx-text-box>
                <dxi-validation-rule
                  type="required"
                  message="{{ dataService.res('Ubt-validator-RequiredField') }}"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item itemType="group" [colCount]="2" [cssClass]="'form-fields-row'">
                <dxi-item>
                  <dx-select-box
                    #responsible
                    fxFill
                    class="dropDownStyle"
                    [searchMode]="'contains'"
                    [(value)]="subProject.IdRefResponsible"
                    valueExpr="Id"
                    [searchEnabled]="true"
                    [label]="dataService.res('Ubt-CreateMeasure-Responsible')"
                    [displayExpr]="dataService.getResponsibleFullName"
                    [dataSource]="RespensiblePersonDataSource"
                    [labelMode]="'floating'"
                  >
                  </dx-select-box>
                </dxi-item>
                <dxi-item style="margin-top: 5px">
                  <dx-select-box
                    #support
                    fxFill
                    class="dropDownStyle"
                    [searchMode]="'contains'"
                    [(value)]="subProject.IdRefResponsibleSupport"
                    valueExpr="Id"
                    [searchEnabled]="true"
                    [label]="dataService.res('Ubt-SubProject-Create-Responsible-Support')"
                    [displayExpr]="dataService.getResponsibleFullName"
                    [dataSource]="ResponsibleSupportPersonDataSource"
                    [labelMode]="'floating'"
                  >
                  </dx-select-box>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" [colCount]="2">
                <dxi-item>
                  <dx-date-box
                    class="date-box-style"
                    [type]="'date'"
                    [stylingMode]="'outlined'"
                    [(value)]="subProject.StartDate"
                    [label]="dataService.res('Ubt-Measure-List-StartDate')"
                    [labelMode]="'floating'"
                    [max]="subProject.EndDate"
                  >
                  </dx-date-box>
                </dxi-item>
                <dxi-item>
                  <dx-date-box
                    class="date-box-style"
                    [(value)]="subProject.EndDate"
                    [type]="'date'"
                    [stylingMode]="'outlined'"
                    [label]="dataService.res('Ubt-Measure-List-EndDate')"
                    [labelMode]="'floating'"
                    [min]="subProject.StartDate"
                  >
                  </dx-date-box>
                </dxi-item>
              </dxi-item>
              <dxi-item itemType="group" [colCount]="2" [cssClass]="'form-fields-row'">
                <!--  <dxi-item>
                  <dx-select-box
                    fxFill
                    class="dropDownStyle"
                    [searchMode]="'contains'"
                    [(value)]="subProject.Company"
                    [searchEnabled]="true"
                    (onValueChanged)="prepareDepartments($event.value)"
                    [label]="dataService.res('Ubt-SubProject-Create-Company')"
                    valueExpr="Id"
                    [dataSource]="dataService.cachedCompany"
                    [displayExpr]="'Name'"
                    [labelMode]="'floating'"
                  >
                  </dx-select-box>
                </dxi-item>
                <dxi-item style="margin-top: 5px">
                  <dx-select-box
                    #departmentSelectBox
                    fxFill
                    class="dropDownStyle"
                    [searchMode]="'contains'"
                    [disabled]="disableDepartment"
                    [(value)]="subProject.Department"
                    valueExpr="Id"
                    [searchEnabled]="true"
                    [label]="dataService.res('Ubt-SubProject-Create-Department')"
                    [dataSource]="dataService.cachedDepartement"
                    [displayExpr]="'Designation'"
                    [labelMode]="'floating'"
                  >
                  </dx-select-box>
                </dxi-item> -->
              </dxi-item>
              <dxi-item [ngStyle]="{ display: isUpdating ? 'block' : 'none' }">
                <dx-text-area
                  [minHeight]="'100px'"
                  [height]="'100px'"
                  fxFill
                  [stylingMode]="'outlined'"
                  [(value)]="subProject.Highlights"
                  [labelMode]="'floating'"
                  [label]="dataService.res('Ubt-SubProject-Create-HighLights')"
                >
                </dx-text-area>
              </dxi-item>
              <dxi-item [ngStyle]="{ display: isUpdating ? 'block' : 'none' }">
                <dx-text-area
                  [minHeight]="'100px'"
                  [height]="'100px'"
                  fxFill
                  [stylingMode]="'outlined'"
                  [(value)]="subProject.Lowlights"
                  [labelMode]="'floating'"
                  [label]="dataService.res('Ubt-SubProject-Create-Lowlights')"
                >
                </dx-text-area>
              </dxi-item>
              <dxi-item>
                <dx-radio-group
                  [items]="subProjectStates"
                  [displayExpr]="'text'"
                  [valueExpr]="'value'"
                  [(value)]="subProject.ImplementationStatus"
                  layout="horizontal"
                  class="test"
                >
                </dx-radio-group>
              </dxi-item>
              <dxi-item itemType="group" [cssClass]="'form-buttons-container'">
                <dxi-item
                  itemType="button"
                  [cssClass]="'submit-button'"
                  [buttonOptions]="{
                    useSubmitBehavior: true,
                    text: this.dataService.res('Ubt-Form-' + this.submitButtonText),
                  }"
                >
                </dxi-item>
                <dxi-item itemType="button" [cssClass]="'cancel-button'" [buttonOptions]="cancelButtonOptions">
                </dxi-item>
              </dxi-item>
            </abc-form>
          </form>
        </div>
      </div>
    </abc-popup>
  </div>
</div>
<abc-popup
  #confirmSubProjectPopup
  [width]="'90%'"
  [maxWidth]="700"
  fxLayout="column"
  fxLayoutAlign="center center"
  [height]="'auto'"
  [title]="dataService.res('Ubt-Company-Title-Confirm-Delete')"
  [showCloseButton]="true"
>
  <div class="dx-card card-paddings card-radius" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
      {{ dataService.res('Ubt-MeasureList-Delete-Message') }}
    </div>
    <dxi-item itemType="group" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="20px">
      <dx-button
        class="submit-button"
        [text]="dataService.res('Ubt-Company-Icon-Delete')"
        (onClick)="removeRow($event)"
      >
      </dx-button>
      <dx-button
        class="cancel-button"
        [text]="dataService.res('Ubt-Company-Button-Cancel')"
        (onClick)="abortTaskDelete()"
      >
      </dx-button>
    </dxi-item>
  </div>
</abc-popup>

<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
